












import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class DetailsLayout extends Vue {
  private async mounted() {
    // blank
  }
}
